import React from "react";
import Scroll from "react-scroll";
import Slider from "../slider/Slider";
import TireFinder from "../tireFinder/TireFinder";
import Highlights from "../tireResults/Highlights";
import ResultProduct from "../tireResults/ResultProduct";
import ResultVehicle from "../tireResults/ResultVehicle";
import ResultSize from "../tireResults/ResultSize";
import ResultSizeSae from "../tireResults/ResultSizeSae";
import StoreDealers from "./StoreDealers";
import StoreFooter from "./StoreFooter";

var Element = Scroll.Element;

export default function StoreContent() {
	return (
		<div className="contenido">
			<Slider />
			<Element
				name="tireFinderElement"
				id="tireFinderElement"
				className="element"
			></Element>
			<TireFinder />
			<Element
				name="resultCarousel"
				id="resultCarousel"
				className="element"
			></Element>
			<Highlights />
			<ResultProduct />
			<ResultVehicle />
			<ResultSize />
			<ResultSizeSae />
			<StoreDealers />
			<StoreFooter />
		</div>
	);
}
